import { render, staticRenderFns } from "./AnalyticsAppDesign.vue?vue&type=template&id=564b2875&"
import script from "./AnalyticsAppDesign.vue?vue&type=script&lang=js&"
export * from "./AnalyticsAppDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports